import {gql} from '@apollo/client'

export const GET_ALL_ORGANIZATIONS = gql`
  query allOrganizations($offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
    allOrganizations(offset: $offset, before: $before, after: $after, first: $first, last: $last) {
      edges {
        node {
          id
          name
          owner
          email
          phone
          website
          streetAddress
          city
          country
          state
          postalCode
          logo
          templateLogo
          isActive
        }
      }
    }
  }
`

export const GET_ORGANIZATION_BY_ID = gql`
  query organizationById($id: String!) {
    organizationById(id: $id) {
      id
      name
      owner
      email
      phone
      website
      streetAddress
      city
      country
      state
      postalCode
      logo
      templateLogo
    }
  }
`
